<template>
  <div v-if="active" class="flex-grow w-full">
    <!-- Header de la pagina de categoria (redireccion instantanea a categoria):
         HTML renderizado en servidor con el mismo partial que la pagina real. -->
    <div v-if="categoryHeader" v-html="categoryHeader"></div>

    <div class="mx-auto px-4 lg:px-8 py-6">

    <!-- Skeletons mientras llega la primera respuesta del termino -->
    <div v-if="skeleton" class="flex flex-col lg:flex-row gap-8">
      <aside
        v-if="!mobileFlag"
        class="hidden lg:block w-72 flex-shrink-0 space-y-6"
      >
        <div class="isk-skeleton rounded-lg" style="height: 260px"></div>
        <div class="isk-skeleton rounded-lg" style="height: 160px"></div>
        <div class="isk-skeleton rounded-lg" style="height: 120px"></div>
      </aside>
      <div class="flex-grow">
        <div class="isk-skeleton rounded mb-4" style="height: 40px"></div>
        <div
          class="grid gap-2 md:gap-4 grid-cols-[repeat(auto-fill,minmax(280px,1fr))]"
        >
          <div
            v-for="n in 10"
            :key="n"
            class="border border-border rounded-lg p-4 bg-white"
          >
            <div
              class="isk-skeleton rounded mb-3"
              style="aspect-ratio: 1 / 1"
            ></div>
            <div class="isk-skeleton rounded mb-2" style="height: 14px"></div>
            <div
              class="isk-skeleton rounded mb-4"
              style="height: 14px; width: 66%"
            ></div>
            <div
              class="isk-skeleton rounded"
              style="height: 22px; width: 40%"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resultados: mismo componente que la pagina del cercador.
         key = termino, para que un termino nuevo reinicie los filtros;
         los cambios de filtro/orden/pagina NO cambian la key (el estado
         de los filtros se conserva y solo se refresca el contenido). -->
    <products
      v-else-if="data"
      :key="renderKey"
      :instant="true"
      :content="data.results"
      :query="categoryBase ? '' : term"
      :user="user"
      :warehouse="warehouse"
      :mobile="mobileFlag"
      :template="1"
      :count_products="data.count_products"
      :brands-to-show="data.brandsToShow"
      :childs="data.childsFilters"
      :childs-categories="data.childrensFromCategories"
      :attributes-filters="data.attributesFilters"
      :max-price="data.maxPrice"
      :min-price="data.minPrice"
      :filter-categories="data.filtersCategories"
      :filter-brands="data.filtersBrands"
      :filter-attributes="data.filtersAttributes"
      :filter-order="data.filterSortBy"
      :filter-per-page="data.filterPerPage"
      :filter-min-price="data.filterMinPrice"
      :filter-max-price="data.filterMaxPrice"
      :filter-query="data.filterQuery"
      :trans-peralba-pro="transPeralbaPro"
      :locale="locale"
      :can-write-orders="canWriteOrders"
      :cart-url="cartUrl"
      :item1="transBuscador.item1"
      :item2="transBuscador.item2"
      :item3="transBuscador.item3"
      :item4="transBuscador.item4"
      :item5="transBuscador.item5"
      :item6="transBuscador.item6"
      :item7="transBuscador.item7"
      :item8="transBuscador.item8"
      :item9="transBuscador.item9"
      :item10="transBuscador.item10"
      :item11="transBuscador.item11"
      :item12="transBuscador.item12"
      :item13="transBuscador.item13"
      :item14="transBuscador.item14"
      :item15="transBuscador.item15"
      :item16="transBuscador.item16"
      :item17="transBuscador.item17"
      :item18="transBuscador.item18"
      :item19="transBuscador.item19"
      :item20="transBuscador.item20"
      :item21="transBuscador.item21"
      :item22="transBuscador.item22"
      :item23="transBuscador.item23"
      :item24="transBuscador.item24"
      :item25="transBuscador.item25"
      :item26="transPeralbaPro.item906"
      :item27="transPeralbaPro.item907"
      :results-loading="resultsLoading"
      @search-params="onParamsChange"
    ></products>
    </div>
  </div>
</template>

<script>
import axios from "axios";

/**
 * Busqueda instantanea (beta, tras el flag SEARCH_INSTANT_USER_IDS).
 *
 * Escucha el evento global 'instant-search-term' que emite el buscador del
 * header (ya debounced a 300ms). Al primer termino oculta el contenido de la
 * pagina (#page-content), muestra skeletons y pide los resultados al endpoint
 * JSON del cercador (?json=1). Las respuestas fuera de orden se descartan
 * (secuencia + AbortController). La URL se mantiene sincronizada con
 * pushState/replaceState para que sea compartible y el boton atras funcione.
 */
export default {
  name: "instant-search",
  props: [
    "searchUrl",
    "cartUrl",
    "user",
    "warehouse",
    "mobile",
    "transPeralbaPro",
    "transBuscador",
    "locale",
    "canWriteOrders",
  ],
  data() {
    return {
      active: false,
      skeleton: false,
      // Cambio de filtros/orden/pagina con resultados ya visibles: las cards
      // del grid se sustituyen por skeletons hasta que llega la respuesta.
      resultsLoading: false,
      term: "",
      data: null,
      renderKey: 0,
      hasPushed: false,
      originalUrl: null,
      // Redireccion instantanea a categoria: header renderizado en servidor y
      // URL base (sin query) de la categoria mostrada. null = modo busqueda.
      categoryHeader: null,
      categoryBase: null,
    };
  },
  computed: {
    mobileFlag() {
      return parseInt(this.mobile) === 1 ? 1 : 0;
    },
  },
  mounted() {
    this._onTermHandler = (e) => {
      this.onTerm(((e.detail && e.detail.term) || "").trim());
    };
    window.addEventListener("instant-search-term", this._onTermHandler);

    // ENTER en el input del header: la unica via por la que una referencia
    // exacta lleva a la ficha del articulo (tecleando nunca se redirige).
    this._onSubmitHandler = (e) => {
      this.onSubmit(((e.detail && e.detail.term) || "").trim());
    };
    window.addEventListener("instant-search-submit", this._onSubmitHandler);

    this._onPopState = (e) => {
      const state = e.state || {};
      if (state.instantSearch && state.categoryUrl) {
        // Volver a una categoria mostrada sin recargar: re-pedir esa URL.
        this.term = state.term || "";
        this.openCategory(state.categoryUrl, {syncHistory: false});
      } else if (state.instantSearch && state.term) {
        // Volver a un estado de busqueda: re-ejecutar ese termino.
        this.term = state.term;
        this.fetchResults({q: state.term}, {fresh: true, syncHistory: false});
      } else {
        // Volver al estado original de la pagina.
        this.deactivate();
      }
    };
    window.addEventListener("popstate", this._onPopState);
  },
  beforeUnmount() {
    window.removeEventListener("instant-search-term", this._onTermHandler);
    window.removeEventListener("instant-search-submit", this._onSubmitHandler);
    window.removeEventListener("popstate", this._onPopState);
  },
  methods: {
    onTerm(term) {
      if (!term) {
        // Input vaciado: restaurar la pagina tal como estaba.
        if (this.active) {
          this.deactivate();
          if (this.hasPushed && this.originalUrl) {
            history.replaceState({}, "", this.originalUrl);
            this.hasPushed = false;
          }
        }
        return;
      }

      if (term === this.term && this.active) return;

      this.term = term;
      this.fetchResults({q: term}, {fresh: true, syncHistory: true});
    },

    onSubmit(term) {
      if (!term) return;
      // Misma busqueda pero sin typing: si el termino es una referencia de un
      // unico articulo, el backend devuelve {redirect} y se va a su ficha.
      // Si ese termino ya esta en pantalla (o cargandose), la respuesta solo
      // sirve para esa redireccion: no se toca lo que se ve.
      if (term === this.term && this.active) {
        this.checkSubmitRedirect(term);
        return;
      }
      this.term = term;
      this.fetchResults({q: term}, {fresh: true, syncHistory: true, submit: true});
    },

    // ENTER sobre el termino que ya se ve: peticion aparte que NO cancela la
    // carga en curso (_abort/_seq). Si la cancelara, un ENTER con la categoria
    // aun cargando (lo normal en movil: "Ir" en el teclado) dejaba los
    // skeletons para siempre, porque una redireccion a categoria se descarta.
    checkSubmitRedirect(term) {
      if (this._submitAbort) this._submitAbort.abort();
      this._submitAbort = new AbortController();

      axios
        .get(this.searchUrl, {
          params: {q: term, json: 1},
          signal: this._submitAbort.signal,
          headers: {Accept: "application/json"},
        })
        .then((r) => {
          if (term !== this.term) return;
          if (r.data && r.data.redirect && r.data.redirectType !== "category") {
            window.location.href = r.data.redirect;
          }
        })
        .catch((e) => {
          if (axios.isCancel(e)) return;
          console.error("instant-search: error comprobando el ENTER", e);
        });
    },

    onParamsChange(params) {
      // Cambio de filtros / orden / paginacion dentro de los resultados:
      // misma peticion JSON, sin skeletons (el grid se actualiza al llegar).
      const query = {
        categories: [].concat(params.categories || []).join(","),
        brands: [].concat(params.brands || []).join(","),
        attributes: [].concat(params.attributes || []).join(","),
        minPrice: params.minPrice ?? "",
        maxPrice: params.maxPrice ?? "",
        sortBy: params.sortBy || "relevance",
        perPage: params.perPage || 25,
        page: params.page || 1,
      };

      if (this.categoryBase) {
        // Filtrando dentro de una categoria mostrada sin recargar: se pide la
        // misma URL de categoria con los filtros (igual que la pagina real).
        const url = this.categoryBase + "?" + this.buildQueryString(query);
        this.fetchCategory(url, {fresh: false, syncHistory: true});
        return;
      }

      query.q = params.q || this.term;
      this.fetchResults(query, {fresh: false, syncHistory: true});
    },

    fetchResults(query, {fresh, syncHistory, submit = false}) {
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();
      const seq = (this._seq = (this._seq || 0) + 1);

      this.activate();
      if (fresh) {
        this.skeleton = true;
        this.scrollTop();
        // Termino nuevo: si se estaba mostrando una categoria, fuera su header.
        this.categoryHeader = null;
        this.categoryBase = null;
      } else {
        this.resultsLoading = true;
      }

      if (syncHistory) this.syncHistory(query);

      axios
        .get(this.searchUrl, {
          // typing=1: el backend no redirige a la ficha de un articulo por
          // referencia mientras se teclea (solo con ENTER, submit).
          params: submit ? {...query, json: 1} : {...query, json: 1, typing: 1},
          signal: this._abort.signal,
          headers: {Accept: "application/json"},
        })
        .then((r) => {
          if (seq !== this._seq) return;

          if (r.data && r.data.redirect) {
            // Categoria con listado: se pinta sin recargar, con la URL de la
            // categoria. Referencia exacta u otra pagina: navegacion real.
            if (r.data.redirectType === "category") {
              this.openCategory(r.data.redirect, {syncHistory: true});
              return;
            }
            window.location.href = r.data.redirect;
            return;
          }

          // Una busqueda normal no lleva header, salvo que un sinonimo de
          // marca la haya convertido en "la pagina de esa marca": entonces el
          // backend devuelve su header ya renderizado.
          this.categoryHeader = r.data.categoryHeader || null;
          this.categoryBase = null;
          this.data = r.data;
          this.skeleton = false;
          this.resultsLoading = false;
          if (fresh) this.renderKey++;
        })
        .catch((e) => {
          if (axios.isCancel(e)) return;
          if (seq !== this._seq) return;
          console.error("instant-search: error cargando resultados", e);
          this.skeleton = false;
          this.resultsLoading = false;
        });
    },

    // Redireccion instantanea a categoria: la URL visible pasa a ser la de la
    // categoria y el contenido (header + productos + filtros) se pide a esa
    // misma URL en modo JSON.
    openCategory(href, {syncHistory}) {
      const u = new URL(href, window.location.origin);
      this.categoryBase = u.origin + u.pathname;
      this.fetchCategory(href, {fresh: true, syncHistory});
    },

    fetchCategory(url, {fresh, syncHistory}) {
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();
      const seq = (this._seq = (this._seq || 0) + 1);

      this.activate();
      if (fresh) {
        this.skeleton = true;
        this.scrollTop();
      } else {
        this.resultsLoading = true;
      }

      if (syncHistory) {
        this.writeHistory(url, {
          instantSearch: true,
          term: this.term,
          categoryUrl: url,
        });
      }

      axios
        .get(url, {
          params: {json: 1},
          signal: this._abort.signal,
          headers: {Accept: "application/json"},
        })
        .then((r) => {
          if (seq !== this._seq) return;
          this.categoryHeader = r.data.categoryHeader || null;
          this.data = r.data;
          this.skeleton = false;
          this.resultsLoading = false;
          if (fresh) this.renderKey++;
        })
        .catch((e) => {
          if (axios.isCancel(e)) return;
          if (seq !== this._seq) return;
          // Si el modo JSON falla, navegacion real a la categoria como fallback.
          console.error("instant-search: error cargando categoria", e);
          window.location.href = url;
        });
    },

    buildQueryString(query) {
      return Object.keys(query)
        .filter(
          (k) => query[k] !== "" && query[k] !== null && query[k] !== undefined,
        )
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(query[k]))
        .join("&");
    },

    syncHistory(query) {
      const url = this.searchUrl + "?" + this.buildQueryString(query);
      this.writeHistory(url, {instantSearch: true, term: this.term});
    },

    writeHistory(url, state) {
      if (!this.hasPushed) {
        // Primera busqueda: una unica entrada nueva en el historial.
        this.originalUrl = this.originalUrl || window.location.href;
        history.pushState(state, "", url);
        this.hasPushed = true;
      } else {
        // Mientras se sigue tecleando o filtrando, se reescribe la misma
        // entrada (no queremos "gri", "grif", "grifo" en el historial).
        history.replaceState(state, "", url);
      }
    },

    activate() {
      if (this.active) return;
      this.active = true;
      const content = document.getElementById("page-content");
      if (content) content.classList.add("hidden");
      // En las pantallas de Peralba Pro los resultados ocupan todo el ancho
      // (como la pagina real del cercador, que no lleva sidebar): la clase
      // oculta el sidebar y quita el hueco/padding del <main>.
      document.body.classList.add("instant-search-active");
    },

    deactivate() {
      this.active = false;
      this.skeleton = false;
      this.resultsLoading = false;
      this.data = null;
      this.term = "";
      this.categoryHeader = null;
      this.categoryBase = null;
      const content = document.getElementById("page-content");
      if (content) content.classList.remove("hidden");
      document.body.classList.remove("instant-search-active");
    },

    scrollTop() {
      const main =
        this.$el && this.$el.closest ? this.$el.closest("main") : null;
      if (main) main.scrollTop = 0;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style>
/* Con la busqueda instantanea activa en una pantalla de Peralba Pro, los
   resultados ocupan todo el ancho: fuera el sidebar y el hueco (lg:ml-64) y
   el padding que el layout le da al <main>, para que se vea igual que la
   pagina real del cercador (que no lleva sidebar). */
body.instant-search-active #sidebar-pro {
  display: none;
}

body.instant-search-active main.peralbapro-main {
  margin-left: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.isk-skeleton {
  background: linear-gradient(90deg, #e9ebee 25%, #f4f5f7 37%, #e9ebee 63%);
  background-size: 400% 100%;
  animation: isk-pulse 1.3s ease infinite;
}

@keyframes isk-pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
